import { getProGroupsMembersListQueryOptions, type ForManagerLocationDetail } from "@sidegigllc/api/client";
import { adminProQueryOptions } from "api/queries/admin";
import { proGroupsQueryOptions } from "api/queries/proGroups";
import { getDirectOfferIds } from "domains/postGig/containers/DirectOfferHeader/directOfferIds";
import type { MarketplaceSearch } from "domains/schedule/utils/useMarketplaceSearch";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = {
  location: Pick<ForManagerLocationDetail, "organization_id" | "market_id"> | undefined;
  search: MarketplaceSearch;
};

export const proGroupsQuery = ({ location, search }: QueriesInput) =>
  proGroupsQueryOptions(
    { organization_id: location?.organization_id, market_id: location?.market_id },
    { enabled: location != null && getDirectOfferIds(search).groupId != null },
  );

export const proQuery = ({ search }: QueriesInput) => {
  const { proId } = getDirectOfferIds(search);
  return adminProQueryOptions(proId, { enabled: !!proId });
};

export const groupMembersQuery = ({ search }: QueriesInput) => {
  const { groupId } = getDirectOfferIds(search);
  return getProGroupsMembersListQueryOptions(groupId ?? 0, { query: { enabled: groupId != null } });
};

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  proGroupsQuery(input),
  proQuery(input),
  groupMembersQuery(input),
];
